import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import AccountForm from "../../components/Accounts/AccountForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";

const AccountsCreate = ({classes, person, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('accounts.new_account')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('accounts.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <AccountForm
                    person={person}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default AccountsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/accounts/Create.jsx